import classNames from 'classnames'
import { extendTailwindMerge } from 'tailwind-merge'
import { customFontSizes } from 'config/customFontSizes'

// The design-system type scale (text-label-medium, text-body-small, ...) is
// not a t-shirt size, so tailwind-merge files it under text colour and drops
// it against classes like text-on-surface. Declare the scale as font sizes so
// both survive a merge.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: Object.keys(customFontSizes) }],
    },
  },
})

export function cn(...inputs: classNames.ArgumentArray) {
  return twMerge(classNames(...inputs))
}
